import { render, staticRenderFns } from "./ProductDisplay.vue?vue&type=template&id=ffa64cee"
import script from "./ProductDisplay.vue?vue&type=script&lang=js"
export * from "./ProductDisplay.vue?vue&type=script&lang=js"
import style0 from "./ProductDisplay.vue?vue&type=style&index=0&id=ffa64cee&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports